module.exports = __webpack_public_path__ + "static/media/memb_page_dancing_chart.8da3e54b.png";